
document.addEventListener("DOMContentLoaded", function () {
    const questions = [
        {
            title: "When you're working on a project, how would you describe your ability to stay focused?",
            options: [
                {text: "I stay on task easily.", points: {DP: 1, RT: 0, MB: 0, DM: 0}},
                {text: "I get sidetracked occasionally.", points: {DP: 0, RT: 1, MB: 0, DM: 1}},
                {text: "My mind tends to wander often.", points: {DP: 0, RT: 0, MB: 0, DM: 2}}
            ],
            // followup: "\"It’s common for attention to ebb and flow throughout the day. ClearMind includes L-Tyrosine, a precursor for dopamine and norepinephrine that helps your body maintain neurotransmitter balance.\""
            followup: "\"Attention naturally ebbs and flows throughout the day. ClearMind’s L-Tyrosine helps your body maintain neurotransmitter balance.\""
        },
        {
            title: "Which statement best reflects your daily schedule?",
            options: [
                {text: "Relaxed and steady.", points: {DP: 0, RT: 1, MB: 1, DM: 0}},
                {text: "Sometimes full, sometimes open.", points: {DP: 0, RT: 1, MB: 0, DM: 1}},
                {text: "Often busy with many responsibilities.", points: {DP: 2, RT: 0, MB: 0, DM: 1}}
            ],
            // followup: "\"A balanced routine can be hard to achieve. ClearMind combines adaptogenic extracts like Ashwagandha and calming L-Theanine to support your body’s stress response.\""
            followup: "\"A balanced routine can be hard to maintain. ClearMind’s Ashwagandha and L-Theanine help support your body’s stress response.\""
        },
        {
            title: "By mid-day, how energized does your mind feel?",
            options: [
                {text: "I feel sharp and alert.", points: {DP: 1, RT: 0, MB: 1, DM: 0}},
                {text: "I feel okay but could use a boost.", points: {DP: 0, RT: 1, MB: 0, DM: 1}},
                {text: "I often feel mentally fatigued.", points: {DP: 1, RT: 1, MB: 0, DM: 0}}
            ],
            // followup: "\"Mental energy depends on healthy mitochondria and acetylcholine. Acetyl-L-Carnitine and Alpha-GPC in ClearMind help sustain mental clarity.\""
            followup: "\"Mental energy relies on healthy mitochondria and acetylcholine. ClearMind’s Acetyl-L-Carnitine and Alpha-GPC help maintain clarity.\""
        },
        {
            title: "How comfortable do you feel when juggling multiple tasks or changes?",
            options: [
                {text: "Very comfortable.", points: {DP: 1, RT: 0, MB: 0, DM: 2}},
                {text: "Moderately comfortable.", points: {DP: 0, RT: 1, MB: 0, DM: 1}},
                {text: "It can be challenging.", points: {DP: 0, RT: 1, MB: 1, DM: 0}}
            ],
            followup: "\"Being flexible is easier when neurotransmitters are balanced. L-Tyrosine supports dopamine and norepinephrine for motivation and focus.\""
        },
        {
            title: "Which describes your approach to relaxation and winding down?",
            options: [
                {text: "I relax easily.", points: {DP: 0, RT: 0, MB: 2, DM: 0}},
                {text: "I find it hard to unwind sometimes.", points: {DP: 0, RT: 1, MB: 1, DM: 0}},
                {text: "Relaxing is tough when I’m stressed.", points: {DP: 1, RT: 0, MB: 0, DM: 1}}
            ],
            followup: "\"Finding calm is important for overall wellness. ClearMind’s Lemon Balm, Ashwagandha, and L-Theanine promote calm focus.\""
        },
        {
            title: "How often do you misplace small items or forget appointments?",
            options: [
                {text: "Rarely.", points: {DP: 1, RT: 0, MB: 1, DM: 0}},
                {text: "Sometimes.", points: {DP: 0, RT: 1, MB: 0, DM: 1}},
                {text: "Often.", points: {DP: 0, RT: 2, MB: 0, DM: 2}}
            ],
            // followup: "\"Short-term recall relies on brain membranes and signaling. ClearMind’s Phosphatidylserine and botanical extracts like Sage support memory and attention.\""
            followup: "\"Short-term recall depends on brain membranes and signaling. ClearMind’s Phosphatidylserine and Sage support memory and focus.\""
        },
        {
            title: "What is your age range?",
            options: [
                {text: "18–34", points: {DP: 1, RT: 0, MB: 0, DM: 1}},
                {text: "35–50", points: {DP: 1, RT: 1, MB: 0, DM: 0}},
                {text: "51–65", points: {DP: 0, RT: 1, MB: 1, DM: 0}},
                {text: "65+", points: {DP: 0, RT: 2, MB: 1, DM: 0}}
            ],
            followup: "\"ClearMind’s nutrient profile supports adults of all ages — from phosphatidylserine for memory to Ashwagandha for balanced stress response.\""
        }
    ];



    const brainTypes = {
        DP: {
            name: "Driven Performer",
            desc: "You thrive on ambition and a full schedule. ClearMind may help sustain your focus and energy so you can stay on top of your goals."
        },
        RT: {
            name: "Reflective Thinker",
            desc: "You enjoy deep thought but sometimes feel mentally foggy or forgetful. ClearMind supports memory and clarity..."
        },
        MB: {
            name: "Mindful Balancer",
            desc: "You value calm and balance. ClearMind’s botanicals help you relax and stay centered while supporting clear thinking."
        },
        DM: {
            name: "Dynamic Multitasker",
            desc: "You juggle multiple tasks and enjoy versatility but sometimes feel scattered. ClearMind supports motivation, attention, and flexible thinking."
        }
    };

    const container = document.getElementById("quiz-questions");
    const resultBox = document.getElementById("quiz-result");
    const progressContainer = document.getElementById("quiz-counter");
    const progress = document.getElementById("quiz-progress");
    const resultTitle = document.getElementById("result-title");
    const resultDesc = document.getElementById("result-desc");

    let currentQ = 0;
    let scores = { DP: 0, RT: 0, MB: 0, DM: 0 };
    let answers = [];
    let lastFollowup = "";

    function renderQuestion() {
        container.innerHTML = "";

        // If there’s a follow-up from previous question, show it on top
        if (lastFollowup) {
            const prevFollow = document.createElement("div");
            prevFollow.className = "quiz-followup active";
            prevFollow.textContent = lastFollowup;
            prevFollow.style.display = "block";
            container.appendChild(prevFollow);
        }

        const q = questions[currentQ];
        progress.textContent = `${currentQ + 1}`;
        const percent = ((currentQ + 1) / questions.length) * 100;

        document.querySelector('.announcement-bar').style.setProperty('--progress-width', `${percent}%`);

        const qDiv = document.createElement("div");
        qDiv.className = "quiz-question active";

        const title = document.createElement("div");
        title.className = "quiz-title";
        title.textContent = q.title;
        qDiv.appendChild(title);

        const optionsDiv = document.createElement("div");
        optionsDiv.className = "quiz-options";

        q.options.forEach((opt, index) => {
            const btn = document.createElement("button");
            btn.textContent = opt.text;

            // highlight previously selected
            if (answers[currentQ] === index) {
                btn.style.background = "#e6f0ff";
                btn.style.borderColor = "#8aff00";
            }

            btn.addEventListener("click", function () {
                answers[currentQ] = index;
                updateScores();

                // Save this follow-up to show above the next question
                lastFollowup = q.followup;

                setTimeout(() => {
                    if (currentQ < questions.length - 1) {
                        currentQ++;
                        renderQuestion();
                    } else {
                        showResult();
                    }
                }, 400);
            });

            optionsDiv.appendChild(btn);
        });

        qDiv.appendChild(optionsDiv);

        // Back button
        if (currentQ > 0) {
            const backBtn = document.createElement("button");
            backBtn.className = "quizBackBtn";
            backBtn.innerHTML = '<i class="fa fa-arrow-left"></i> Back';

            backBtn.addEventListener("click", () => {
                currentQ--;
                lastFollowup = currentQ > 0 ? questions[currentQ - 1].followup : "";
                renderQuestion();
            });
            qDiv.appendChild(backBtn);
        }

        container.appendChild(qDiv);
    }

    function updateScores() {
        scores = { DP: 0, RT: 0, MB: 0, DM: 0 };
        answers.forEach((ans, idx) => {
            if (ans !== undefined) {
                const opt = questions[idx].options[ans];
                Object.keys(opt.points).forEach(k => {
                    scores[k] += opt.points[k];
                });
            }
        });
    }

    function showResult() {
        container.style.display = "none";
        resultBox.style.display = "block";
        progress.style.display = "none";
        progressContainer.style.display = "none";
        document.querySelector('.announcement-bar').style.setProperty('--progress-width', `0`);


        console.log(scores);

        const maxType = Object.keys(scores).reduce((a, b) => scores[a] > scores[b] ? a : b);

        console.log(maxType);
        resultTitle.textContent = brainTypes[maxType].name;
        resultDesc.textContent = brainTypes[maxType].desc;
    }

    renderQuestion();
});



